import { Typography } from "@mui/material";
import React from "react";

export default function PaymentLinkEmptyScreen() {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        marginTop: "90px",
      }}
    >
      <img
        src="/assets/emptySearch.svg"
        alt="emptySearch"
        style={{ marginBottom: "20px" }}
      />
      <Typography className="bodyB2Medium font-black-highest">
        No record found
      </Typography>
      <Typography
        className="labelRegular font-black-high"
        style={{ marginTop: "8px" }}
      >
        Please search the valid payment link and try again
      </Typography>
    </div>
  );
}
